import styled from 'styled-components';

const ImageWrapper = styled.div`
  width: 100%;
`;

export { ImageWrapper };
